import { Component } from 'react'
import { API, Auth } from 'aws-amplify'
import config from './Config'

const apiPath = config.apiGatewayProvider.PATH

class ProviderClient extends Component {
    async getGoogleReviews(companyName) {
		const data = {
			companyName
		}
		console.log(data)

		return API.post(apiPath, 'companies/reviews', {
			body: data
		})
	}

	async getCompany() {
		const info = await Auth.currentUserInfo()
		const data = {
			url: info.attributes['custom:companyUrl']
		}
		console.log(data)

		return API.post(apiPath, 'companies/get', {
			body: data
		})
	}

	async requestUrlChange(email, currentUrl, requestedUrl) {
		const data = {
			email,
			currentUrl,
			requestedUrl
		}
		console.log(data)

		return API.post(apiPath, 'companies/request-url-change', {
			body: data
		})
	}

	async updateProfileDetails(companyId, profileDetails) {
		const data = {
			companyId,
			profileDetails
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-profile', {
			body: data
		})
	}

	async updateProfileDetailsExtended(companyId, profileDetails) {
		const data = {
			companyId,
			profileDetails
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-profile-extended', {
			body: data
		})
	}

	async updateCoverage(companyId, coverageType, counties, eircodeAreas) {
		const data = {
			companyId,
			coverageType,
			counties,
			eircodeAreas
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-coverage', {
			body: data
		})
	}

	async addProject(companyId, project) {
		const data = {
			companyId,
			project
		}
		console.log(data)

		return API.post(apiPath, 'companies/add-project', {
			body: data
		})
	}

	async updateProfileBullets(companyId, bullets) {
		const data = {
			companyId,
			bullets
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-bullets', {
			body: data
		})
	}

	async updatePrimaryPerson(companyId, primaryPerson) {
		const data = {
			companyId,
			primaryPerson
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-person', {
			body: data
		})
	}

	async updateTeam(companyId, team) {
		const data = {
			companyId,
			team
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-team', {
			body: data
		})
	}

	async submitProfile(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'companies/submit-profile', {
			body: data
		})
	}

	async unsubmitProfile(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'companies/unsubmit-profile', {
			body: data
		})
	}

	async skipRegistration(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'companies/skip-registration', {
			body: data
		})
	}

	async updatePlanDetails(companyId, planDetails) {
		const data = {
			companyId,
			planDetails
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-plan', {
			body: data
		})
	}

	async updatePaymentDetails(companyId, paymentDetails) {
		const data = {
			companyId,
			paymentDetails
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-payment', {
			body: data
		})
	}

	async updateDeliveryDetails(companyId, deliveryDetails) {
		const data = {
			companyId,
			deliveryDetails
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-delivery', {
			body: data
		})
	}

	async submitVerification(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'companies/submit-verification', {
			body: data
		})
	}

	async updateSurvey(companyId, surveyDetails) {
		const data = {
			companyId,
			surveyDetails
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-survey', {
			body: data
		})
	}

	async updateProjects(companyId, projects) {
		const data = {
			companyId,
			projects
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-projects', {
			body: data
		})
	}

	async updateTechnology(companyId, technology) {
		const data = {
			companyId,
			technology
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-technology', {
			body: data
		})
	}

	async updateProductCoverage(companyId, product, coverageType, counties, eircodeAreas) {
		const data = {
			companyId,
			product,
			coverageType,
			counties,
			eircodeAreas
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-coverage', {
			body: data
		})
	}

	async updateAllCoverage(companyId, coverage) {
		const data = {
			companyId,
			coverage
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-coverage', {
			body: data
		})
	}

	async updateVerification(companyId, verification) {
		const data = {
			companyId,
			verification
		}
		console.log(data)

		return API.post(apiPath, 'companies/update-verification', {
			body: data
		})
	}

	async setPauseRequest(companyId, pauseRequested) {
		const data = {
			companyId,
			pauseRequested
		}
		console.log(data)

		return API.post(apiPath, 'companies/set-pause-request', {
			body: data
		})
	}

	async getBrands() {
		return API.post(apiPath, 'products/brands', {})
	}

	async getPayments(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'payments/list', {
			body: data
		})
	}

	async getSetupIntent(companyId, type) {
		const data = {
			companyId,type
		}
		console.log(data)

		return API.post(apiPath, 'stripe/create-setup-intent', {
			body: data
		})
	}

	async setDefaultPaymentMethod(companyId, paymentMethodId) {
		const data = {
			companyId,
			paymentMethodId
		}
		console.log(data)

		return API.post(apiPath, 'stripe/set-payment-method', {
			body: data
		})
	}

	async getPaymentMethod(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'stripe/get-payment-method', {
			body: data
		})
	}

	async getPaymentIntent(companyId, total, mode) {
		const data = {
			companyId,
			total,
			mode
		}
		console.log(data)

		return API.post(apiPath, 'stripe/create-payment-intent', {
			body: data
		})
	}

	async makePaymentExisting(payment) {
		const data = {
			payment
		}
		console.log(data)

        return API.post(apiPath, 'stripe/create-payment-intent-off', {
            body: data
        })
	}

	async createUserAccount(firstName, lastName, email, companyName, companyUrl) {
		// add to invite table
		const password = this.generatePassword()
		try {
			// Create cognito user
			let cognitoData = {
				'username': email, 
				'password': password,
				'attributes': {
					'name': firstName + ' ' + lastName,
					'email': email,
					'custom:companyName': companyName,
					'custom:companyUrl': companyUrl
				}
			}
			console.log(cognitoData)

			await Auth.signUp(cognitoData)
			const data = {
				firstName,
				companyName,
				email,
				password
			}
			console.log(data)
			return API.post(apiPath, 'companies/new-user', {
				body: data
			})
		} catch(e) {
			throw new Error(e)
		}
	}

	generatePassword() {
		const alpha = 'abcdefghijklmnopqrstuvwxyz'
		const calpha = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
		const num = '1234567890'
		const specials = '$!@'
		const options = [alpha, alpha, alpha, calpha, calpha, num, num, specials]
		let opt, choose
		let pass = ''
		
		for ( let i = 0; i < 8; i++ ) {
			opt = Math.floor(Math.random() * options.length)
			choose = Math.floor(Math.random() * (options[opt].length))
			pass = pass + options[opt][choose]
			options.splice(opt, 1)
		}

		return pass
	}

	async checkWebsiteBadge(companyId, url) {
		const data = {
			companyId,
			url
		}
		console.log(data)

		return API.post(apiPath, 'companies/check-badge', {
			body: data
		})
	}

	async sendDeveloperInstructions(url, email) {
		const data = {
			url,
			email
		}
		console.log(data)

		return API.post(apiPath, 'companies/send-developer-email', {
			body: data
		})
	}

	async requestCall(companyId, day, time, note) {
		const data = {
			companyId,
			day,
			time,
			note
		}
		console.log(data)

		return API.post(apiPath, 'companies/request-call', {
			body: data
		})
	}

	// Confirm top-up after successful payment so backend records balance increment
	async confirmTopup(companyId, paymentIntentId, total) {
		const data = {
			companyId,
			paymentIntentId,
			total
		}
		console.log(data)

		return API.post(apiPath, 'companies/confirm-topup', {
			body: data
		})
	}

	async getCurrentBalance(companyId) {
		const data = {
			companyId
		}
		console.log(data)

		return API.post(apiPath, 'companies/balance', {
			body: data
		})
	}
} 

export default ProviderClient